import styled from 'styled-components';

export const PersonalInfoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex: 4;
  flex-wrap: wrap;
  h1 {
    font-size: 40px;
    margin: 0;
    padding: 0;
    font-family: ${(props) => props.theme.fonts.roboto};
    font-weight: 700;
    color: ${(props) => props.theme.colors.white};
    margin-bottom: 0.6rem;
  }

  h2 {
    font-size: 17px;
    margin: 0;
    padding: 0 0.5rem;
    font-family: ${(props) => props.theme.fonts.roboto};
    font-weight: 400;
    color: ${(props) => props.theme.colors.white};
  }

  img {
    height: 30px;
    width: 30px;
  }
  p {
    font-size: 30px;
    padding: 0.5rem;
    color: white;
  }

  @media (max-width: 576px) {
    .info-container {
      flex-direction: column;
    }
    p {
      display: none;
    }
  }
`;

export const OuterPersonalInfoWrapper = styled.div`
  padding: 5rem 0rem;
  display: flex;

  background-color: ${(props) =>
    props.dark ? props.theme.colors.dark : props.theme.colors.blue};
  width: 100%;
`;
